import * as React from "react";

const SvgAvatar = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
     <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    ><path fill="currentColor" d="M2330 4853 c-942 -101 -1724 -756 -1985 -1663 -65 -224 -80 -344 -80
-630 0 -223 3 -271 24 -385 58 -328 183 -638 361 -899 358 -526 898 -876 1520
-986 156 -28 476 -38 631 -21 940 107 1714 757 1973 1658 66 228 81 346 81
633 0 223 -3 271 -24 385 -181 1011 -971 1767 -1984 1900 -108 14 -417 19
-517 8z m491 -278 c773 -102 1420 -634 1663 -1365 172 -517 134 -1078 -104
-1552 -107 -213 -216 -364 -385 -534 -552 -556 -1378 -741 -2122 -476 -278
100 -532 261 -749 477 -490 486 -698 1197 -548 1873 185 832 868 1461 1713
1577 130 17 402 18 532 0z"/></g>
<g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    ><path d="M2450 4360 c-467 -60 -745 -426 -717 -944 17 -308 110 -544 332 -846
90 -123 98 -140 93 -221 -6 -105 -54 -153 -219 -218 -169 -68 -448 -216 -619
-330 -104 -69 -216 -179 -253 -247 l-27 -52 47 -63 c65 -86 201 -227 292 -303
680 -566 1669 -569 2356 -6 145 119 352 356 340 389 -19 50 -79 131 -139 188
-131 124 -350 247 -646 364 -162 63 -220 94 -271 144 -43 42 -54 77 -47 159 6
72 41 139 143 276 174 235 269 498 281 780 20 470 -207 817 -596 910 -98 23
-257 32 -350 20z"/></g>
  </svg>
);

export default SvgAvatar;
